import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Layout } from "./components/macaron/Layout";
import ProductPage from "./pages/ProductPage";
import ServicesPage from "./pages/ServicesPage";
import GetToKnowUsPage from "./pages/GetToKnowUsPage";
import CareerPathPage from "./pages/CareerPathPage";
import ContactPage from "./pages/ContactPage";

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route element={<Layout />}>
          <Route path="/" element={<ProductPage />} />
          <Route path="/services" element={<ServicesPage />} />
          <Route path="/about" element={<GetToKnowUsPage />} />
          <Route path="/careers" element={<CareerPathPage />} />
          <Route path="/contact" element={<ContactPage />} />
        </Route>
      </Routes>
    </BrowserRouter>
  );
}

export default App;
